import { render, staticRenderFns } from "./CustomerAssetEditForm.vue?vue&type=template&id=488cc7ef"
import script from "./CustomerAssetEditForm.vue?vue&type=script&lang=js"
export * from "./CustomerAssetEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports